import { getGroupConfigSubdomain } from "@/configuration/paths";
import { ConfigSubdomain } from "@/configuration/tenant-ids";
import { Group } from "@/src/models/group";

// Groups whose EHR shows MRNs zero-padded and matches only the padded value (InSync), so staff
// see the MRN exactly as the EHR does. Every other group displays MRNs without leading zeros.
const ZERO_PADDED_MRN_DISPLAY_SUBDOMAINS = new Set<string>([ConfigSubdomain.FCC]);

export function displaysZeroPaddedMrn(group: Group): boolean {
  return ZERO_PADDED_MRN_DISPLAY_SUBDOMAINS.has(getGroupConfigSubdomain(group));
}
